import React, { useState } from 'react'
import { LinkContainer } from 'react-router-bootstrap'

import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'
import Collapse from 'react-bootstrap/Collapse'
import Nav from 'react-bootstrap/Nav'

export default function DashboardMenu() {
  const [attendeesOpen, setAttendeesOpen] = useState(false)

  const [reportsOpen, setReportsOpen] = useState(false)

  const [marketingOpen, setMarketingOpen] = useState(false)

  return (
    <>
      <Stack as="ul" gap={1} className="nav-list">
        <Nav.Item as="li">
          <LinkContainer to="">
            <Nav.Link>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5 22C3.34315 22 2 20.6569 2 19V11.3361C2 10.4857 2.36096 9.67518 2.99311 9.10625L9.9931 2.80625C11.134 1.77943 12.866 1.77943 14.0069 2.80625L21.0069 9.10625C21.639 9.67518 22 10.4857 22 11.3361V19C22 20.6569 20.6569 22 19 22H5ZM20 11.3361V19C20 19.5523 19.5523 20 19 20H16V15C16 13.3432 14.6569 12 13 12H11C9.34315 12 8 13.3432 8 15V20H5C4.44772 20 4 19.5523 4 19V11.3361C4 11.0526 4.12032 10.7825 4.33104 10.5928L11.331 4.29284C11.7113 3.95056 12.2887 3.95056 12.669 4.29284L19.669 10.5928C19.8797 10.7825 20 11.0526 20 11.3361ZM10 20V15C10 14.4478 10.4477 14 11 14H13C13.5523 14 14 14.4478 14 15V20H10Z"
                  fill="#6F767E"
                />
              </svg>
              Dashboard
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
        <Nav.Item as="li">
          <LinkContainer to="event-details">
            <Nav.Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7 11.0098C7 10.4575 7.44772 10.0098 8 10.0098H16C16.5523 10.0098 17 10.4575 17 11.0098C17 11.5621 16.5523 12.0098 16 12.0098H8C7.44772 12.0098 7 11.5621 7 11.0098Z"
                  fill="#777E91"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7 15.0098C7 14.4575 7.44772 14.0098 8 14.0098H12C12.5523 14.0098 13 14.4575 13 15.0098C13 15.5621 12.5523 16.0098 12 16.0098H8C7.44772 16.0098 7 15.5621 7 15.0098Z"
                  fill="#777E91"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21 19.0098C21 20.6666 19.6569 22.0098 18 22.0098H6C4.34315 22.0098 3 20.6666 3 19.0098V5.00977C3 3.35291 4.34315 2.00977 6 2.00977H16L16.0107 2.02047C16.7136 2.08002 17.3761 2.38586 17.8787 2.88845L20.1213 5.13109C20.6239 5.63367 20.9297 6.29621 20.9893 6.99906L21 7.00977V19.0098ZM18 20.0098H6C5.44772 20.0098 5 19.562 5 19.0098V5.00977C5 4.45748 5.44771 4.00977 6 4.00977H15V6.00977C15 7.11434 15.8954 8.00977 17 8.00977H19V19.0098C19 19.562 18.5523 20.0098 18 20.0098Z"
                  fill="#777E91"
                />
              </svg>
              Event details
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
        <Nav.Item as="li">
          <LinkContainer to="event-settings">
            <Nav.Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 14.0098C13.1046 14.0098 14 13.1143 14 12.0098C14 10.9052 13.1046 10.0098 12 10.0098C10.8954 10.0098 10 10.9052 10 12.0098C10 13.1143 10.8954 14.0098 12 14.0098ZM16 12.0098C16 14.2189 14.2091 16.0098 12 16.0098C9.79086 16.0098 8 14.2189 8 12.0098C8 9.80063 9.79086 8.00977 12 8.00977C14.2091 8.00977 16 9.80063 16 12.0098Z"
                  fill="#777E91"
                />
                <path
                  xmlns="http://www.w3.org/2000/svg"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.3791 3.00977L10.9915 4.17243C10.6165 5.29732 9.79908 6.08001 8.96536 6.54424C8.90606 6.57725 8.84735 6.61121 8.78923 6.6461C7.96925 7.13836 6.88111 7.45588 5.71804 7.21787L4.51627 6.97195L4.91723 5.01255L6.11901 5.25848C6.68428 5.37415 7.26514 5.22834 7.75983 4.93136C7.83655 4.8853 7.91408 4.84046 7.9924 4.79685C8.49591 4.51649 8.91189 4.0867 9.09413 3.53997L9.48168 2.37731C9.75391 1.56063 10.5182 1.00977 11.3791 1.00977H12.621C13.4819 1.00977 14.2462 1.56062 14.5184 2.37731L14.9059 3.53997C15.0882 4.0867 15.5042 4.51649 16.0077 4.79685C16.086 4.84046 16.1635 4.8853 16.2402 4.93136C16.7349 5.22833 17.3158 5.37414 17.881 5.25847L19.0828 5.01255C19.9262 4.83997 20.7854 5.22642 21.2158 5.97195L21.8368 7.04752C22.2672 7.79305 22.1723 8.73036 21.6011 9.37446L20.7862 10.2935C20.4042 10.7242 20.2392 11.2986 20.2483 11.8741C20.2497 11.9645 20.2497 12.055 20.2483 12.1453C20.2392 12.7209 20.4042 13.2953 20.7862 13.7259L21.6011 14.645C22.1723 15.2891 22.2672 16.2264 21.8368 16.9719L21.2158 18.0475C20.7854 18.793 19.9262 19.1795 19.0828 19.0069L17.8811 18.761C17.3158 18.6453 16.735 18.7912 16.2403 19.0881C16.1635 19.1342 16.086 19.1791 16.0077 19.2227C15.5042 19.503 15.0882 19.9328 14.9059 20.4796L14.5184 21.6422C14.2462 22.4589 13.4819 23.0098 12.621 23.0098H11.3791C10.5182 23.0098 9.75391 22.4589 9.48169 21.6422L9.09413 20.4796C8.91189 19.9328 8.49591 19.503 7.9924 19.2227C7.91406 19.1791 7.83651 19.1342 7.75977 19.0881C7.26507 18.7911 6.68421 18.6453 6.11892 18.761L4.91723 19.0069C4.07385 19.1795 3.21465 18.793 2.78422 18.0475L2.16324 16.9719C1.73281 16.2264 1.82773 15.2891 2.39888 14.645L3.89529 15.9719L4.51627 17.0475L5.71796 16.8016C6.88105 16.5636 7.9692 16.8811 8.78918 17.3734C8.84732 17.4083 8.90605 17.4423 8.96536 17.4753C9.79908 17.9395 10.6165 18.7222 10.9915 19.8471L11.3791 21.0098L12.621 21.0098L13.0086 19.8471C13.3835 18.7222 14.201 17.9395 15.0347 17.4753C15.094 17.4423 15.1527 17.4083 15.2109 17.3734C16.0309 16.8811 17.119 16.5636 18.2821 16.8016L19.4837 17.0475L20.1047 15.9719L19.2898 15.0529C18.505 14.1679 18.2334 13.0704 18.2486 12.1137C18.2497 12.0444 18.2497 11.9751 18.2486 11.9058C18.2334 10.9491 18.505 9.85157 19.2898 8.96658L20.1047 8.04752L19.4837 6.97195L18.282 7.21786C17.1189 7.45587 16.0308 7.13835 15.2108 6.6461C15.1527 6.61121 15.094 6.57725 15.0347 6.54424C14.201 6.08001 13.3835 5.29732 13.0086 4.17243L12.621 3.00976L11.3791 3.00977ZM2.39888 14.645L3.89529 15.9719L4.71031 15.0528C5.49507 14.1679 5.76666 13.0703 5.75151 12.1136C5.75041 12.0444 5.75041 11.9751 5.75151 11.9059C5.76667 10.9492 5.49508 9.85162 4.71032 8.96663L3.89529 8.04752L4.51627 6.97195L4.91723 5.01255C4.07385 4.83996 3.21465 5.22642 2.78422 5.97195L2.16324 7.04752C1.73281 7.79305 1.82773 8.73036 2.39888 9.37446L3.21391 10.2936C3.59582 10.7243 3.76088 11.2986 3.75176 11.8742C3.75033 11.9645 3.75033 12.055 3.75176 12.1453C3.76087 12.7208 3.59582 13.2952 3.21391 13.7259L2.39888 14.645Z"
                  fill="#777E91"
                />
              </svg>
              Event settings
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
        <Nav.Item as="li">
          <LinkContainer to="seatmap">
            <Nav.Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.6545 4.01172H12.3455C10.1124 4.01172 8.16364 5.92176 8.16364 8.4524V14.5371H16.8364V8.4524C16.8364 5.92176 14.8876 4.01172 12.6545 4.01172ZM6.16364 8.4524C6.16364 4.89531 8.93133 2.01172 12.3455 2.01172H12.6545C16.0687 2.01172 18.8364 4.89531 18.8364 8.4524V15.249C18.8364 15.5873 18.7112 15.8952 18.5064 16.125C18.2807 16.3785 17.9581 16.5371 17.6 16.5371H7.4C7.04189 16.5371 6.71935 16.3785 6.49356 16.125C6.28882 15.8952 6.16364 15.5873 6.16364 15.249V8.4524ZM20.8364 12.6264C20.6949 12.4379 20.4747 12.3168 20.2273 12.3168C19.8005 12.3168 19.4545 12.6773 19.4545 13.1219V19.2405C19.4545 19.6852 19.8005 20.0456 20.2273 20.0456C20.4265 20.0456 20.6082 19.967 20.7452 19.838C20.9017 19.6907 21 19.4776 21 19.2405V13.1219C21 12.935 20.9389 12.763 20.8364 12.6264ZM18.0182 20.9338C18.4265 20.6716 18.744 19.8055 18.8193 19.2405C18.8305 19.1566 18.8364 19.0794 18.8364 19.0117C18.8364 18.6995 18.7866 18.4872 18.6949 18.3469C18.4978 18.0456 18.107 18.0771 17.6 18.1654C17.5525 18.1737 17.504 18.1824 17.4545 18.1915C17.4327 18.1954 17.4107 18.1995 17.3885 18.2036C17.0279 18.2697 16.6195 18.3447 16.187 18.3447H8.81299C8.38046 18.3447 7.97214 18.2697 7.61151 18.2036C7.58931 18.1995 7.56729 18.1954 7.54545 18.1915C7.49599 18.1824 7.44749 18.1737 7.4 18.1654C6.893 18.0771 6.50221 18.0456 6.30512 18.3469C6.21341 18.4872 6.16364 18.6995 6.16364 19.0117C6.16364 19.0794 6.16948 19.1566 6.18066 19.2405C6.25596 19.8055 6.57355 20.6716 6.98179 20.9338C7.05939 20.9837 7.14026 21.0117 7.22338 21.0117H17.7766C17.8597 21.0117 17.9406 20.9837 18.0182 20.9338ZM16.8354 18.9763C16.8354 18.9763 16.8355 18.9774 16.8356 18.9799ZM8.16465 18.9763C8.16465 18.9763 8.16459 18.9775 8.16437 18.9799ZM4.2548 19.838C4.39184 19.967 4.57348 20.0456 4.77273 20.0456C5.19949 20.0456 5.54545 19.6852 5.54545 19.2405V13.1219C5.54545 12.6773 5.19949 12.3168 4.77273 12.3168C4.52532 12.3168 4.30507 12.4379 4.16364 12.6264C4.06111 12.763 4 12.935 4 13.1219V19.2405C4 19.4776 4.09833 19.6907 4.2548 19.838Z"
                  fill="#777E91"
                />
              </svg>
              Seat map
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
        <Nav.Item as="li">
          <LinkContainer to="offers">
            <Nav.Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.5855 5.41105L12.7968 4.3709C12.3966 3.84316 11.6033 3.84316 11.2031 4.3709L10.4144 5.41105C9.95592 6.01574 9.20684 6.32602 8.45504 6.22266L7.16185 6.04485C6.50574 5.95464 5.94475 6.51563 6.03496 7.17174L6.21277 8.46493C6.31614 9.21673 6.00586 9.96581 5.40116 10.4243L4.36101 11.213C3.83328 11.6132 3.83328 12.4065 4.36101 12.8067L5.40116 13.5954C6.00586 14.0539 6.31614 14.803 6.21277 15.5548L6.03496 16.848C5.94475 17.5041 6.50574 18.0651 7.16185 17.9749L8.45504 17.7971C9.20684 17.6937 9.95592 18.004 10.4144 18.6087L11.2031 19.6488C11.6033 20.1765 12.3966 20.1765 12.7968 19.6488L13.5855 18.6087C14.044 18.004 14.7931 17.6937 15.5449 17.7971L16.8381 17.9749C17.4942 18.0651 18.0552 17.5041 17.965 16.848L17.7872 15.5548C17.6838 14.803 17.9941 14.0539 18.5988 13.5954L19.6389 12.8067C20.1667 12.4065 20.1667 11.6132 19.6389 11.213L18.5988 10.4243C17.9941 9.96581 17.6838 9.21673 17.7872 8.46493L17.965 7.17174C18.0552 6.51563 17.4942 5.95464 16.8381 6.04485L15.5449 6.22266C14.7931 6.32602 14.044 6.01574 13.5855 5.41105ZM14.3905 3.1625C13.19 1.5793 10.8099 1.5793 9.60947 3.1625L8.82077 4.20265C8.79894 4.23144 8.76327 4.24622 8.72747 4.2413L7.43428 4.06349C5.46593 3.79286 3.78297 5.47582 4.0536 7.44417L4.23141 8.73735C4.23633 8.77315 4.22156 8.80883 4.19276 8.83066L3.15261 9.61935C1.56941 10.8198 1.56941 13.1999 3.15261 14.4004L4.19276 15.189C4.22156 15.2109 4.23633 15.2466 4.23141 15.2824L4.0536 16.5755C3.78297 18.5439 5.46593 20.2269 7.43428 19.9562L8.72747 19.7784C8.76327 19.7735 8.79894 19.7883 8.82077 19.8171L9.60947 20.8572C10.8099 22.4404 13.19 22.4404 14.3905 20.8572L15.1792 19.8171C15.201 19.7883 15.2367 19.7735 15.2725 19.7784L16.5657 19.9562C18.534 20.2269 20.217 18.5439 19.9463 16.5755L19.7685 15.2824C19.7636 15.2466 19.7784 15.2109 19.8072 15.189L20.8473 14.4003C22.4305 13.1999 22.4305 10.8198 20.8473 9.61936L19.8072 8.83066C19.7784 8.80883 19.7636 8.77315 19.7685 8.73735L19.9463 7.44417C20.217 5.47582 18.534 3.79286 16.5657 4.06349L15.2725 4.2413C15.2367 4.24622 15.201 4.23144 15.1792 4.20265L14.3905 3.1625Z"
                  fill="#777E91"
                />
                <path
                  d="M14.7071 10.7169L10.7071 14.7169C10.3166 15.1074 9.68342 15.1074 9.29289 14.7169C8.90237 14.3263 8.90237 13.6932 9.29289 13.3027L13.2929 9.30266C13.6834 8.91213 14.3166 8.91213 14.7071 9.30266C15.0976 9.69318 15.0976 10.3263 14.7071 10.7169Z"
                  fill="#777E91"
                />
                <path
                  d="M11 10.0098C11 10.5621 10.5523 11.0098 10 11.0098C9.44772 11.0098 9 10.5621 9 10.0098C9 9.45748 9.44772 9.00977 10 9.00977C10.5523 9.00977 11 9.45748 11 10.0098Z"
                  fill="#777E91"
                />
                <path
                  d="M13 14.0098C13 14.5621 13.4477 15.0098 14 15.0098C14.5523 15.0098 15 14.5621 15 14.0098C15 13.4575 14.5523 13.0098 14 13.0098C13.4477 13.0098 13 13.4575 13 14.0098Z"
                  fill="#777E91"
                />
              </svg>
              Offers
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
        {/* {process.env.NODE_ENV !== "production" && ( */}
        <Nav.Item as="li">
          <LinkContainer to="assign-tickets">
            <Nav.Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g id="Icons/UI icon/group/light">
                  <path
                    id="Subtract"
                    d="M14.4998 10.9791C16.4731 10.7332 18.0001 9.0499 18.0001 7.00999C18.0001 4.97007 16.4731 3.2868 14.4998 3.04089C15.4335 4.09864 16.0001 5.48815 16.0001 7.00999C16.0001 8.53183 15.4335 9.92133 14.4998 10.9791Z"
                    fill="#777E91"
                  />
                  <path
                    id="Subtract_2"
                    d="M20 20.01C20 20.5622 20.4477 21.01 21 21.01C21.5523 21.01 22 20.5622 22 20.01V18.01C22 15.3499 19.9227 13.1749 17.3018 13.0189C18.3539 13.9507 19.1587 15.1553 19.6055 16.522C19.8565 16.9605 20 17.4685 20 18.01V20.01Z"
                    fill="#777E91"
                  />
                  <path
                    id="Vector 631 (Stroke)"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 15.01C5.34315 15.01 4 16.3532 4 18.01V20.01C4 20.5623 3.55228 21.01 3 21.01C2.44772 21.01 2 20.5623 2 20.01V18.01C2 15.2486 4.23858 13.01 7 13.01H13C15.7614 13.01 18 15.2486 18 18.01V20.01C18 20.5623 17.5523 21.01 17 21.01C16.4477 21.01 16 20.5623 16 20.01V18.01C16 16.3532 14.6569 15.01 13 15.01H7Z"
                    fill="#777E91"
                  />
                  <path
                    id="Ellipse 132 (Stroke)"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 5.01001C8.89543 5.01001 8 5.90544 8 7.01001C8 8.11458 8.89543 9.01001 10 9.01001C11.1046 9.01001 12 8.11458 12 7.01001C12 5.90544 11.1046 5.01001 10 5.01001ZM6 7.01001C6 4.80087 7.79086 3.01001 10 3.01001C12.2091 3.01001 14 4.80087 14 7.01001C14 9.21915 12.2091 11.01 10 11.01C7.79086 11.01 6 9.21915 6 7.01001Z"
                    fill="#777E91"
                  />
                </g>
              </svg>
              Assign tickets
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
        <Nav.Item as="li">
          <LinkContainer to="resale-tickets">
            <Nav.Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.75 6H18.25C20 6 20 6 20 7.75V10.5A1.5 1.5 0 0 1 20 13.5V16.25C20 18 20 18 18.25 18H5.75C4 18 4 18 4 16.25V13.5A1.5 1.5 0 0 1 4 10.5V7.75C4 6 4 6 5.75 6ZM7.6 8.15H16.4C17.15 8.15 17.15 8.15 17.15 8.9V15.1C17.15 15.85 17.15 15.85 16.4 15.85H7.6C6.85 15.85 6.85 15.85 6.85 15.1V8.9C6.85 8.15 6.85 8.15 7.6 8.15ZM8.4 9.4H11.6V8.7L14.5 10L11.6 11.3V10.6H8.4V9.4ZM15.6 13.4H12.4V12.7L9.5 14L12.4 15.3V14.6H15.6V13.4Z"
                  fill="#777E91"
                />
              </svg>
              Resale tickets
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
        <Nav.Item as="li">
          <LinkContainer to="waitlist">
            <Nav.Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.1 4.6H15.1A1.1 1.1 0 0 1 15.1 6.8H5.1A1.1 1.1 0 0 1 5.1 4.6ZM5.1 9H10.1A1.1 1.1 0 0 1 10.1 11.2H5.1A1.1 1.1 0 0 1 5.1 9ZM5.1 13.4H8.4A1.1 1.1 0 0 1 8.4 15.6H5.1A1.1 1.1 0 0 1 5.1 13.4ZM12.4 15.2A5 5 0 1 1 22.4 15.2A5 5 0 1 1 12.4 15.2ZM14.25 15.2A3.15 3.15 0 1 0 20.55 15.2A3.15 3.15 0 1 0 14.25 15.2ZM16.7 12.7H18.1V14.5H19.8V15.9H16.7V12.7Z"
                  fill="#777E91"
                />
              </svg>
              Waitlist
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
      </Stack>
      <Stack as="ul" gap={2} className="nav-list">
        <Nav.Item as="li">
          <Button
            variant="default"
            className="btn-toggle w-100"
            onClick={() => setMarketingOpen(!marketingOpen)}
            aria-controls="marketing-collapse"
            aria-expanded={marketingOpen}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4.26663 14.9453C4.26335 15.0488 4.26806 15.1541 4.28136 15.2605L4.70957 18.6862C4.87569 20.0152 6.00541 21.0124 7.34471 21.0124C8.81138 21.0124 10.0004 19.8235 10.0004 18.3568V15.2951C9.34627 15.1362 8.67624 15.0433 8.00036 15.0189V18.3568C8.00036 18.7189 7.70681 19.0124 7.34471 19.0124C7.01405 19.0124 6.73514 18.7662 6.69413 18.4381L6.26592 15.0124C8.74285 15.0124 6.24665 15.0124 5.00024 15.0124C4.74966 15.0124 4.50445 14.9894 4.26663 14.9453Z"
                fill="#777E91"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.63932 9.01305H5C3.89543 9.01305 3 9.90848 3 11.0131C3 12.1176 3.89543 13.0131 5 13.0131H7.63932C9.50226 13.0131 11.3396 13.4468 13.0059 14.2799L18.5528 17.0534C19.2177 17.3858 20 16.9023 20 16.1589V5.86715C20 5.12377 19.2177 4.64028 18.5528 4.97272L13.0059 7.74618C11.3396 8.57931 9.50226 9.01305 7.63932 9.01305ZM5 7.01305C2.79086 7.01305 1 8.80391 1 11.0131C1 13.2222 2.79086 15.0131 5 15.0131H7.63932C9.19177 15.0131 10.7229 15.3745 12.1115 16.0688L17.6584 18.8422C19.6531 19.8396 22 18.3891 22 16.1589V5.86715C22 3.63701 19.6531 2.18652 17.6584 3.18387L12.1115 5.95732C10.7229 6.6516 9.19177 7.01305 7.63932 7.01305H5Z"
                fill="#777E91"
              />
              <path
                d="M11 15.5929C10.3518 15.3616 9.68156 15.1979 9 15.1043V6.9183C9.68156 6.8247 10.3518 6.66098 11 6.42969V15.5929Z"
                fill="#777E91"
              />
              <path
                d="M22 12.927C22.5826 12.721 23 12.1654 23 11.5123V10.5123C23 9.85919 22.5826 9.30357 22 9.09766V12.927Z"
                fill="#777E91"
              />
            </svg>
            Marketing
          </Button>
          <Collapse in={marketingOpen}>
            <ul id="marketing-collapse" className="submenu">
              <Nav.Item as="li">
                <LinkContainer to="tracking-links">
                  <Nav.Link>Tracking links</Nav.Link>
                </LinkContainer>
              </Nav.Item>
            </ul>
          </Collapse>
        </Nav.Item>
      </Stack>
    </>
  )
}
